module.exports = __webpack_public_path__ + "static/media/kuro-innovation.ca951e8b.svg";